/*jshint esversion: 6 */
import Vue from 'vue';

const initialState = () => ({
//types:
  // etc
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getULObject: (state) => (payload) => {
    let object = state;
    payload.path.forEach(entry => {
      if (Object.values(entry)[0] !== '') {
        object = object[Object.keys(entry)[0]][Object.values(entry)[0]];
      } else {
        object = object[Object.keys(entry)[0]];
      }
    });
    return object;
  },
};

// Actions
const actions = {
  createULObject({commit, getters}, payload){
    let object = getters.getWBLObject(payload);
    payload.object = object;
    commit('create_ul_objects', payload);
  },
  updateULObject({commit, getters}, payload) {
    let object = getters.getWBLObject(payload);
    payload.object = object;
    commit('update_ul_object', payload);
  },
  deleteULObject({commit, getters}, payload) {
    let object = getters.getULObject(payload);
    payload.object = object;
    commit('delete_ul_object', payload);
  },
};

// Mutations
const mutations = {
  //object mutations
  create_ul_objects(state, payload) {
    if (payload.wbl_object.position) {
      let position = payload.wbl_object.position;
      delete payload.wbl_object.position;
      payload.object.splice(position-1, 0, payload.wbl_object);
    } else {
      payload.object.push(payload.wbl_object);
    }
  },
  update_ul_object(state, payload){
    Object.assign(payload.object, payload.update);
  },
  delete_ul_object(state, payload) {
    Vue.delete(payload.object, payload.index);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
